module.exports = __webpack_public_path__ + "img/TOP.3f02ca6a.jpg";